import { styled } from 'goober';

export const BaseCell = styled('div')<{ isFullWidth?: boolean }>`
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: ${({ isFullWidth }) => (isFullWidth ? `1 0 100%;` : `1 0 48%;`)};
`;
